import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import React, { ReactNode } from 'react';
import TooltipHardened from '../TooltipHardened';
interface Props {
  label: string;
  value: boolean;
  tooltip?: ReactNode;
}

export const StyledCheckbox = ({
  label,
  value,
  tooltip,
  ...props
}: Props & Omit<CheckboxProps, 'checked' | 'color'>): React.JSX.Element => (
  <TooltipHardened arrow tooltip={tooltip}>
    <FormControlLabel
      sx={{ margin: 0, userSelect: 'none' }}
      label={label}
      control={<Checkbox {...props} checked={value} color={'secondary'} />}
    />
  </TooltipHardened>
);
